import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import ArrowBack from "@material-ui/icons/ArrowBack";
import { logout, resetImages } from "../actions";
import ImageSearch from "./ImagePortal/ImageSearch";
import { withRouter } from "react-router";

class NavBar extends React.Component {
  render() {
    console.log("[NAVBAR] RENDER");
    const back = show => {
      if (show) {
        return (
          <Button onClick={this.props.history.goBack}>
            <ArrowBack />
          </Button>
        );
      }
    };
    const imageSearch = show => {
      if (show) {
        return <ImageSearch />;
      }
    };

    return (
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        style={{
          background: "#fff",
          borderBottom: "1px solid #e6e6e",
          marginLeft: "250px",
          width: "calc( 100% - 250px)"
        }}
      >
        <Toolbar>
          {back(this.props.navBar.back)}
          <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
            {this.props.navBar.title}
          </Typography>

          {imageSearch(this.props.location.pathname.includes("image-portal"))}

          <Button
            onClick={() => {
              this.props.logout();
              this.props.resetImages();
            }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
    );
  }
}

function mapStateToProps(state) {
  return {
    navBar: state.navBar
  };
}

NavBar.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  navBar: PropTypes.object,
  logout: PropTypes.func,
  resetImages: PropTypes.func
};

export default withRouter(
  connect(mapStateToProps, { logout, resetImages })(NavBar)
);
